import styled from 'styled-components';

export const SocialIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 4px;

  > * + * {
    margin-left: 12px;
  }
`;
